import React from "react";

const GradientLine: React.FC = () => {
  return <div className={"gradient_line"} />;
};

export default GradientLine;
